import { useState } from "react";
import axios from "axios";
import { Container, Accordion, Table, Button } from "react-bootstrap";

export default function BulkLoadExams(props) {
  const API_URL = process.env.REACT_APP_BACKEND_URL + "/api";
  const RESPONSE_OK = "OK";
  const MAX_COLUMNS = 6;
  const ls = require("localstorage-ttl");

  const [isLoading, setLoading] = useState(false);
  const [file, setFile] = useState();
  const [array, setArray] = useState([]);

  const token = JSON.parse(ls.get("jwt"));
  const usuario = JSON.parse(ls.get("userData"));
  const fileReader = new FileReader();

  const headerRequest = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  const handleOnChange = (e) => {
    setFile(e.target.files[0]);
  };

  const handleOnSubmit = (e) => {
    e.preventDefault();
    if (file) {
      fileReader.onload = function (event) {
        const text = event.target.result;
        csvFileToArray(text);
      };
      fileReader.readAsText(file);
    }
  };

  const csvFileToArray = (string) => {
    const csvRows = string.slice(string.indexOf("\n") + 1).split("\n");
    let array = csvRows.map((i) => {
      let row = i.split(";");
      row = row.map((e) => {
        return e.trim();
      });
      row[row.length] = "A procesar";
      return row;
    });
    array = array.filter((row) => row && row.length === MAX_COLUMNS + 1);

    setArray(array);
  };

  const saveData = (e) => {
    e.preventDefault();
    setLoading(true);
    Promise.all(
      array.map(async (item) => {
        if (item[MAX_COLUMNS] !== RESPONSE_OK) {
          const reqUser = {
            data: {
              docNumber: item[0],
              lastname: item[1],
              name: item[2],
              birthDate: item[3],
              startDate: item[4],
              email: item[5],
              state: "NEW",
              createdByUser: usuario.id,
            },
          };
          await axios
            .post(`${API_URL}/temp-users`, reqUser, headerRequest)
            .then(() => {
              item[MAX_COLUMNS] = RESPONSE_OK;
            })
            .catch((error) => {
              setLoading(false);
              console.log("Error with post temp-exams:", error.response);
              item[MAX_COLUMNS] = "ERROR";
            });
        }
        return item;
      })
    )
      .then((items) => setArray(items))
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <Container className="p-3 mb-4 bg-light rounded-3">
      <h4>CARGA MASIVA ALUMNOS</h4>
      <p>Seleccione un archivo CSV según corresponda e importe los datos.</p>

      <div style={{ textAlign: "center" }}>
        <Accordion
          style={{ maxWidth: "600px", margin: "0 auto" }}
          className="p-1 mb-4"
          flush
        >
          <Accordion.Item eventKey="0">
            <Accordion.Header>Ejemplo de Formato del archivo</Accordion.Header>
            <Accordion.Body style={{ textAlign: "left" }}>
              DNI;APELLIDO;NOMBRES;FNAC;FINGRESO;EMAIL
              <br />
              20923000;GARCIA;PEDRO;1968-01-03;2005-08-01;pgarcia@test.com
              <br />
              9001234;PEREZ;JUAN CARLOS;1972-10-19;2002-12-10;ajc@test.com.ar
            </Accordion.Body>
          </Accordion.Item>
        </Accordion>
        <form>
          <input
            type={"file"}
            id={"fileInput"}
            accept={".csv"}
            onChange={handleOnChange}
          />
          <Button
            size="sm"
            variant="success"
            disabled={isLoading}
            onClick={(e) => {
              handleOnSubmit(e);
            }}
          >
            CARGAR
          </Button>
        </form>
      </div>
      {array.length > 0 ? (
        <>
          <Table striped hover size="sm" className="mt-3" responsive="sm">
            <thead>
              <tr>
                <th>DNI</th>
                <th>Apellido</th>
                <th>Nombres</th>
                <th>Fecha Nac.</th>
                <th>Fecha Ingreso</th>
                <th>Email</th>
                <th>Resultado</th>
              </tr>
            </thead>
            <tbody>
              {isLoading ? (
                <tr>
                  <td colSpan="7">Leyendo....</td>
                </tr>
              ) : (
                array.map((item, i) => (
                  <tr key={i}>
                    {Object.values(item).map((val) => (
                      <td>{val}</td>
                    ))}
                  </tr>
                ))
              )}
            </tbody>
          </Table>
          <Button
            size="sm"
            variant="success"
            disabled={isLoading}
            onClick={(e) => {
              saveData(e);
            }}
          >
            IMPORTAR
          </Button>
        </>
      ) : null}
    </Container>
  );
}
